export function isLoggingInFromAccountsSubdomain() {
  const hostname = window.location.hostname
  return hostname.startsWith('accounts.')
}

/**
 * Checks that a return path is a path on the current origin, so it can't be
 * used to send the user to another site (e.g. `//evil.com`, `/\evil.com`,
 * `https://evil.com`).
 */
export function isSafeReturnPath(
  returnPath: string | null | undefined | false,
): returnPath is string {
  if (typeof returnPath !== 'string' || !returnPath.startsWith('/')) {
    return false
  }
  const base = 'https://return-path.invalid'
  try {
    return new URL(returnPath, base).origin === base
  } catch {
    return false
  }
}

/**
 * URL for the backend auth-transfer redirect that signs the user in to the
 * given business's site. The return path is carried over as `next` so the
 * user lands on the page they asked for rather than the business's home page.
 * Only the path is carried over: the destination host is always the business.
 */
export function getBusinessTransferUrl(
  businessHostname: string,
  returnPath?: string | null | false,
): string {
  const params = new URLSearchParams({ business_hostname: businessHostname })
  if (isSafeReturnPath(returnPath) && returnPath !== '/') {
    params.set('next', returnPath)
  }
  return `/api-auth/transfer-start/?${params.toString()}`
}
